import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-promotionnotification',
    template: require('./promotionnotification.component.html'),
    styles: []
})
export class PromotionNotificationComponent implements OnInit {
    api: any;
    private gridColumnApi;
    private columnDefs;
    private rowData;
    private rowHeight;

    constructor() {
        this.columnDefs = [
            {
                headerName: 'Action', field: 'action', width: 100, pinned: 'left', cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
            <div class="grid_actions">
                <span class="grid_actions_item viewBtn"><i class="icon-edit"></i></span>
                <span class="grid_actions_item viewBtn"><i class="icon-delete"></i></span>
            </div>
            `;
                    return eDiv;
                }
            },
            { headerName: 'Promotion Name', field: 'promotion', width: 300 },
            { headerName: 'Description', field: 'description', width: 300 },
            { headerName: 'Campaign', field: 'campaign', width: 120 },
            {
                headerName: 'Send Notification', field: 'sendnotification', width: 170, cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
            <div class="grid_actions">
                <span class="grid_actions_item"><i class="icon-mail-send"></i></span>
                <span class="grid_actions_item"><i class="icon-tick"></i></span>
            </div>
            `;
                    return eDiv;
                }
            },
        ];

        this.rowData = [
            { promotion: 'Wheel Chair Promotion', description: 'Test', campaign: 'Yes' },
            { promotion: 'Wheel Chair Promotion', description: 'Test', campaign: 'Yes' },
            { promotion: 'Wheel Chair Promotion', description: 'Test', campaign: 'No' },
        ];
        this.rowHeight = 50;
    }



    ngOnInit() {
    }

    onGridReady(params) {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

}
